/**
 * Regole condivise tra app e strumenti (pure, senza accesso ai dati).
 */

/** Confronto di nomi: maiuscole, accenti, apostrofi e "/" al posto di "-" non contano. */
export const stessoNome = (a: string | undefined, b: string | undefined) => !!a && !!b && chiaveNome(a) === chiaveNome(b);

export const chiaveNome = (s: string) =>
  s
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/['’`]/g, "")
    .replace(/\//g, "-")
    .replace(/\s*-\s*/g, "-")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export interface AmbitoFornitore {
  categorie: string[];
  /** vuoto = tutte le sedi */
  sedi: string[];
  /** vuoto = tutti i servizi */
  servizi: string[];
}

/**
 * Un fornitore è indicato per una richiesta se copre la sua categoria e,
 * quando li ha indicati, la sua sede e il suo servizio.
 */
export function fornitoreIndicato(
  f: AmbitoFornitore,
  r: { categoria?: string; sede?: string; servizio?: string },
): boolean {
  const tra = (lista: string[], v: string | undefined) => lista.some((x) => stessoNome(x, v));
  return (
    tra(f.categorie, r.categoria) &&
    (f.sedi.length === 0 || tra(f.sedi, r.sede)) &&
    (f.servizi.length === 0 || tra(f.servizi, r.servizio))
  );
}
